let fetching = false;
let fetched = false;

function status(response) {
  if (response.status >= 200 && response.status < 300) {
    return Promise.resolve(response);
  } else {
    return Promise.reject(new Error(response.statusText));
  }
}

export default player => {
  // we don't have need for nonce
  if (!player.config.analytics && !player.config.automations) {
    return;
  }

  window?.wp?.hooks?.addAction('presto.playerPlaying', 'presto-player', () => {
    window?.wp.hooks.doAction('presto.playerGetNonce');
  });

  // get nonce refresh
  window?.wp.hooks.addAction('presto.playerGetNonce', 'presto-player', () => {
    // bail if we are already getting it or got it
    if (fetching || fetched) {
      return;
    }

    // we're fetching
    fetched = true;

    // fetch it
    fetch(`${window?.prestoPlayer?.ajaxurl}?action=presto_refresh_progress_nonce`)
      .then(status)
      .then(response => response.json())
      .then(({ data }) => {
        const nonce = data;
        window?.wp.hooks.doAction('presto.nonceRefreshed', nonce);
        // we got it
        fetching = true;
      })
      .catch(function (error) {
        console.log('Request failed', error);
      })
      .finally(() => {
        // we're done fetching
        fetched = false;
      });
  });
};
